import React, { useEffect, useState } from 'react'
import './Registration.css'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { MdPersonAddAlt1 } from 'react-icons/md'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { Link, useNavigate } from 'react-router-dom'

export const Registration = () => {
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  const token = localStorage.getItem('token')
  const [emailError, setEmailErr] = useState('')
  const [phone, setPhone] = useState('')

  // set input values
  const [data, setData] = useState({
    name: '',
    email: '',
    password: '',
    contact: '',
    role: '',
  })

  // input onchange
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setData({ ...data, [name]: value })
  }

  let id = '@inferenz.ai'
  // add new user(Admin/HR/Interviewer)
  const submit = async (e) => {
    e.preventDefault()
    await axios
      .post(
        Baseurl.nodeLocal + 'enduser/registration',

        {
          email: data.email.concat(id),
          name: data.name,
          contact: phone,
          role: data.role,
          password: string,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })

        // after response clear input values
        setData({ name: '', email: '', password: '', contact: '', role: '' })
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  // emial validation (it must be @inferenz.ai)
  const emailValidation = (evnt) => {
    const emailInputValue = evnt.target.value.trim()
    const emailInputFieldName = evnt.target.name
    //for password
    if (emailInputFieldName === 'email') {
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/

      const emailLength = emailInputValue.length

      const specialCharPassword = specialCharRegExp.test(emailInputValue)

      let errMsg = ''
      if (emailLength === 0) {
        errMsg = ''
      } else if (specialCharPassword) {
        errMsg = 'Provide Username only!'
      } else {
        errMsg = ''
      }
      setEmailErr(errMsg)
    }
  }

  var retVal = ''
  const [string, setString] = useState('')
  const generatePassword = () => {
    var length = 8,
      charset =
        '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ'

    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n))
      setString(retVal)
    }
    return retVal
  }

  useEffect(() => {
    generatePassword()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Sidebar />

      <div className="container registration d-flex align-items-center justify-content-center flex-column">
        <div className=" mt-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/home" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                <Link to="/userList" className="link text-primary">
                  Users
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Add New User
              </li>
            </ol>
          </nav>
        </div>
        <form onSubmit={submit} className="d-flex justify-content-center">
          <div className="card border border-0 form mt-5">
            <div className="headerimg">
              <MdPersonAddAlt1 className="registerIcon" />
            </div>

            <div className="card-body">
              {/* <h3 className="text-center">Add User</h3> */}
              <div className="row">
                <div className="col-md-6 form-floating mb-3 mt-4">
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="name"
                    name="name"
                    onChange={handleChange}
                    value={data.name}
                    required
                  />
                  <label
                    htmlFor="floatingInput"
                    style={{ marginLeft: '0.5rem' }}
                  >
                    Name
                  </label>
                </div>
                <div className="col-md-6 form-floating mb-3 mt-4">
                  <PhoneInput
                    country={'in'}
                    value={phone}
                    onChange={setPhone}
                    enableSearch
                    inputStyle={{ width: '13rem', height: '3.59rem' }}
                  />
                </div>
              </div>

              <div className="input-group mb-1">
                <div className="col-md form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    placeholder="name@example.com"
                    name="email"
                    onChange={handleChange}
                    onKeyUp={emailValidation}
                    value={data.email}
                    required
                  />
                  <label htmlFor="floatingInput">Email address</label>
                </div>
                <span className="input-group-text">@inferenz.ai</span>
              </div>
              {emailError ? <h6 className="text-danger">{emailError}</h6> : ''}

              <div className="form-floating mt-3">
                <select
                  className="form-select  mb-3"
                  id="validationCustom04"
                  style={{ height: 55 }}
                  name="role"
                  onChange={handleChange}
                  value={data.role}
                  required
                >
                  <option value="" disabled selected>
                    Select
                  </option>

                  <option value="Admin">Admin</option>
                  <option value="HR">HR</option>
                  <option value="Interviewer">Interviewer</option>
                  <option value="Accounts">Accounts</option>
                </select>
                <label htmlFor="validationCustom04">Select role</label>
              </div>
              <div className="d-grid gap-2 col-5 mx-auto">
                <button
                  className={
                    data.name === '' ||
                    data.email === '' ||
                    data.role === '' ||
                    phone === ''
                      ? 'btn disabled md-3'
                      : 'btn md-3 '
                  }
                  type="submit"
                  style={{ backgroundColor: '#4a77f7', color: 'white' }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
